import DailyReservationGroup from '@/model/reservation/DailyReservationGroup'
import _ from 'lodash'

export default class DailyReservationHeader {

  static createFromResponse (responseData: any): any {

    let groupSlots:any[] = []
    responseData.forEach( (item:any) => {

      const foundSlotIndex:number | undefined = _.findIndex(groupSlots, function(sitem:any) {
        return sitem.menuGroupSlot.id === item.menuGroupSlot.id;
      });

      if( foundSlotIndex === -1 )
      {
        groupSlots.push({menuGroup:item.menuGroup,menuGroupSlot:item.menuGroupSlot})
      }

    })

    let groups:any[] = []
    groupSlots.forEach( (item:any) => {
      const foundIndex:number | undefined = _.findIndex(groups, function(sitem:any) {
        return sitem.menuGroup.id === item.menuGroup.id;
      });

      console.log("foundIndex",foundIndex)

      if( foundIndex === -1 )
      {
        groups.push({menuGroup:item.menuGroup,menuGroupSlot:[item.menuGroupSlot]})
      }else{
        groups[foundIndex].menuGroupSlot.push(item.menuGroupSlot)
      }
    })

    return groups
  }
}
